import { render, staticRenderFns } from "./ModalAtalhoTerritorio.vue?vue&type=template&id=251391b8&lang=pug"
import script from "./ModalAtalhoTerritorio.vue?vue&type=script&lang=js"
export * from "./ModalAtalhoTerritorio.vue?vue&type=script&lang=js"
import style0 from "./ModalAtalhoTerritorio.vue?vue&type=style&index=0&id=251391b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports